module.exports = __webpack_public_path__ + "static/media/prototype-soma.45b8add7.mp4";